import { post } from "@/util/http";

console.log("==========================");
console.log("当前版本:", VERSION, "当前环境:", ENV);
console.log("==========================");

import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import ElementUI, { Message } from "element-ui";
import VueLazyload from "vue-lazyload";
import VueQriously from "vue-qriously";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/reset.css";
import "@/assets/theme-variables.css";
import "@/assets/font.css";
import "@/assets/iconfont/iconfont.css";
import "swiper/swiper-bundle.css";
import { store } from "./store/index.js";
import SVGA from "svgaplayerweb";
import VueClipboard from "vue-clipboard2";
import IdleVue from "idle-vue";
import * as echarts from "echarts";
import MetaInfo from "vue-meta-info";
import * as utils from "@/util/time";
import { fixedNumber } from "@/util/picNumber";
import i18n from "./locales";
import "@/assets/element-variables.scss";
import DOMPurify from "dompurify";

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 2000,
});
Vue.use(VueClipboard);
Vue.use(VueQriously);
Vue.use(ElementUI);
Vue.use(VueLazyload);
Vue.use(MetaInfo);

Vue.config.productionTip = false;
Vue.prototype.$message = Message;
Vue.prototype.$SVGA = SVGA;
Vue.prototype.$util = utils;
Vue.prototype.$num = (value) => {
  return value.replace(/\D/g, "");
};

Vue.prototype.$numAndText = (value) => {
  return value.replace(/[\u0391-\uFFE5]/g, "");
};

Vue.prototype.$bigNumber = (num) => {
  if (num >= 10000 && localStorage.getItem("language") == "zh-CN") {
    num = fixedNumber(num / 10000, 1) + "W";
  } else if (num >= 1000 && localStorage.getItem("language") == "en-US") {
    num = fixedNumber(num / 1000, 1) + "K";
  }
  return num;
};

// 全局DOMPurify消毒方法
Vue.prototype.$purifyHTML = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html);
};

// document.title = "龙门直播_龙门直播视频_龙门体育赛事直播";

Vue.prototype.$echarts = echarts;

const app = new Vue({
  store,
  i18n,
  router,
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
  render: (h) => h(App),
});
// post({ url: "/api/home/getLongMenBg" }).then((result) => {
//   console.log("decodeResponse", result);
//   if (result.status === 200) {
//     const res = result.data;

//     if (res.status === 0) {
//       window.key2 = res.data.image_url;
//     }
//   }
// });
app.$mount("#app");
